// extracted by mini-css-extract-plugin
module.exports = {"timer":"_19102","item":"_1629","divider":"_5367","rectangle":"_12336"};